import React, { useEffect, useState } from 'react';
import IntroScreen from '@/components/diagnostic/IntroScreen';
import PreFilterScreen from '@/components/diagnostic/PreFilterScreen';
import AuditScreen from '@/components/diagnostic/AuditScreen';
import ContactInfoScreen from '@/components/diagnostic/ContactInfoScreen';
import ResultsScreen from '@/components/diagnostic/ResultsScreen';
import RedirectScreen from '@/components/diagnostic/RedirectScreen';

const SCREENS = {
  INTRO: 'intro',
  PREFILTER: 'prefilter',
  REDIRECT: 'redirect',
  AUDIT: 'audit',
  CONTACT_INFO: 'contact_info',
  RESULTS: 'results',
};

export default function DiagnosticPage() {
  const [currentScreen, setCurrentScreen] = useState(SCREENS.INTRO);
  const [preFilterData, setPreFilterData] = useState({});
  const [auditData, setAuditData] = useState({});
  const [contactInfo, setContactInfo] = useState({});

useEffect(() => {
    console.log(process.env.REACT_APP_BACKEND_URL);
  }, []);

  const handleStartDiagnostic = () => {
    setCurrentScreen(SCREENS.PREFILTER);
  };

  const handlePreFilterComplete = (data) => {
    setPreFilterData(data);
    
    // Check routing rules:
    // If logements >= 10 OR CA >= 10000€ → redirect to Audit Structure
    const shouldRedirect = 
      data.logements === '10+' || 
      data.chiffreAffaires === '10k+';
    
    if (shouldRedirect) {
      setCurrentScreen(SCREENS.REDIRECT);
    } else {
      setCurrentScreen(SCREENS.AUDIT);
    }
  };

  const handleAuditComplete = (data) => {
    setAuditData(data);
    setCurrentScreen(SCREENS.CONTACT_INFO);
  };

  const handleContactInfoComplete = (data) => {
    setContactInfo(data);
    setCurrentScreen(SCREENS.RESULTS);
  };

  const handleRestart = () => {
    setPreFilterData({});
    setAuditData({});
    setContactInfo({});
    setCurrentScreen(SCREENS.INTRO);
  };

  return (
    <main className="min-h-screen">
      {currentScreen === SCREENS.INTRO && (
        <IntroScreen onStart={handleStartDiagnostic} />
      )}
      
      {currentScreen === SCREENS.PREFILTER && (
        <PreFilterScreen 
          onComplete={handlePreFilterComplete}
          onBack={() => setCurrentScreen(SCREENS.INTRO)}
        />
      )}
      
      {currentScreen === SCREENS.REDIRECT && (
        <RedirectScreen onRestart={handleRestart} />
      )}
      
      {currentScreen === SCREENS.AUDIT && (
        <AuditScreen 
          preFilterData={preFilterData}
          onComplete={handleAuditComplete}
          onBack={() => setCurrentScreen(SCREENS.PREFILTER)}
        />
      )}

      {currentScreen === SCREENS.CONTACT_INFO && (
        <ContactInfoScreen
          onComplete={handleContactInfoComplete}
          onBack={() => setCurrentScreen(SCREENS.AUDIT)}
        />
      )}
      
      {currentScreen === SCREENS.RESULTS && (
        <ResultsScreen 
          preFilterData={preFilterData}
          auditData={auditData}
          contactInfo={contactInfo}
          onRestart={handleRestart}
        />
      )}
    </main>
  );
}